<template>
  <div class="step4">
    <p>{{ $t('cart_page.success_order_desc1') }}</p>
    <p>{{ $t('cart_page.success_order_desc2') }}</p>
    <p>{{ $t('cart_page.success_order_desc3') }}</p>
    <p>{{ $t('cart_page.success_order_desc4') }}</p>
    <div class="btns">
      <div class="btn btn-grey" @click="handleNext">{{ $t('cart_page.back_to_cart') }}</div>
      <div class="btn btn-orange" @click="gotoHome">{{ $t('cart_page.continue') }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cart-step4',
    methods: {
      gotoHome() {
        this.$emit('next','cart');
        this.$router.push({name:'Home'});
      },
      handleNext() {
        this.$emit('next','cart');
      },
    }
  }
</script>

<style lang="less" scoped>
.step4 {
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 992px) {
    justify-content: center;
  }
  p {
    margin-bottom: 14px;
    font-weight: 300;
  }
  .btns {
    margin-top: 30px;
  }
}
</style>